<template>
    <section
        v-editable="blok"
        class="featured-tours"
    >
        <KSectionHeader
            v-if="title || blok.eyebrow || blok.text"
            class="featured-tours__header"
            :eyebrow="blok.eyebrow"
            :text="blok.text"
            :align="blok.align || 'start'"
        >
            <template
                v-if="title"
                #title
            >
                <span v-html="title" />
            </template>
            <template
                v-if="blok.action_label && (blok.action_link?.url || blok.action_link?.email || blok.action_link?.cached_url || blok.action_link?.anchor)"
                #actions
            >
                <StoryblokSectionHeaderAction
                    :label="blok.action_label"
                    :link="blok.action_link"
                    placement="featured-tours"
                />
            </template>
        </KSectionHeader>

        <div
            v-if="featuredTours.length"
            class="featured-tours__grid"
        >
            <TourCard
                v-for="entry in featuredTours"
                :key="entry.item._uid || entry.tour.uuid"
                :tour="entry.tour"
                :title="entry.title"
                :title-html="Boolean(entry.title)"
                :description="entry.item.text"
                :image="entry.item.image"
                :detail="blok.detail"
                @select="track(entry.tour, $event)"
            />
        </div>
    </section>
</template>

<script setup>
import { KSectionHeader } from '@vemedia/karibu'
import TourCard from '~/components/tour-card/tour-card.vue'
import renderHighlightedText from '~/helpers/renderHighlightedText'

const { blok } = defineProps(['blok'])
const { capture } = useTracking()

function highlightedText(document) {
    if (!document?.content?.length)
        return ''
    const copy = { ...document, content: document.content.map(node => ({ ...node })) }
    return renderHighlightedText(copy)
}

const title = computed(() => highlightedText(blok.title))
const selections = computed(() => Array.isArray(blok.tours) ? blok.tours : [])
const selectedUuids = computed(() => selections.value.map(item => item.tour).filter(Boolean))

const { data: tours } = await useAsyncData(
    `featured-tours-${blok._uid}`,
    () => selectedUuids.value.length
        ? $fetch('/api/tours', { query: { uuids: selectedUuids.value.join(',') } })
        : Promise.resolve([]),
    {
        default: () => [],
        watch: [selectedUuids],
    },
)

const featuredTours = computed(() => {
    const byUuid = new Map(tours.value.map(tour => [tour.uuid, tour]))
    return selections.value.flatMap((item) => {
        const tour = byUuid.get(item.tour)
        return tour ? [{ item, tour, title: highlightedText(item.title) }] : []
    })
})

function track(tour, action) {
    capture('featured_tour_clicked', {
        placement: 'featured-tours',
        target_slug: tour.full_slug,
        action,
    })
}
</script>

<style lang="scss">
@use 'featured-tours';
</style>
